import React, { useState } from "react";
import { Popup } from "semantic-ui-react";
import CreateMcq from "./CreateMcq";
import CreateUploadType from "./CreateUploadType";
import ThreeDot from "./ThreeDot";
import { useEffect } from "react";
import axios from "../../../axios";
import CrossAttachmentAssessment from "../../../Assesment/pages/Create_Assessment/Attachment/CrossAttachmentAssessment";
import Guides from "../../../Homework/pages/Create_Assessment/Create_Question/Create_Q_Type/Guides";
export default function DefaultQuestion({
  questionNo,
  question,
  setQuestions,
  questionBankDetails,
  setSkillsData,
  setQuestionType,
  setDifficulty_levelData
}) {
  const [fileSizeerror, setFileSizeError] = useState("");
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  let school_id = JSON.parse(localStorage.getItem("schoolId"));
  const timeTableSessionId = JSON.parse(localStorage.getItem('timeTableSessionId'))
  const [click, setClick] = useState(false)

  const [dropdownList, setDropdownList] = useState({
    skills: null,
    types: null,
    domains: null,
    chapters: null,
    difficultyLevels: null,
  });
  const { skills, types, domains, chapters, difficultyLevels } = dropdownList;
  useEffect(() => {
    try {
      const getDetails = async () => {
        let skills = await axios.get(`/api/v1/school/skill/get`);
        if (skills) {
          setDropdownList((prev) => ({ ...prev, skills: skills.data.data }));
          setSkillsData(skills?.data?.data)
        }


        let chapters = await axios.get(
          `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${questionBankDetails?.standard_id?.id}&section_id=${questionBankDetails?.section_id?.id}&subject_id=${questionBankDetails?.subject_id?.id}&timetableSessionId=${timeTableSessionId}`
          // `/api/v1/school/book/get/standardId/${questionBankDetails?.standard_id?.id}?sectionId=${questionBankDetails?.section_id?.id}&subjectId=${questionBankDetails?.subject_id?.id}&isWithChapters=true`
        );
        chapters &&
          setDropdownList((prev) => ({ ...prev, chapters: chapters.data.data }));
        let domains = await axios.get(`/api/v1/school/domain/get`);
        domains &&
          setDropdownList((prev) => ({ ...prev, domains: domains.data.data }));

        let types = await axios.get(
          `/api/v1/questionType/get/school/${school_id}`
        );
        if (types) {
          setDropdownList((prev) => ({ ...prev, types: types.data.data }));
          setQuestionType(types.data.data)
        }

        let difficultyLevels = await axios.get(`/api/v1/difficultyLevel/get`);
        if (difficultyLevels) {
          setDropdownList((prev) => ({
            ...prev,
            difficultyLevels: difficultyLevels.data.data,
          }));
          setDifficulty_levelData(difficultyLevels.data.data)
        }


      };
      getDetails();
    } catch (error) {
      console.log(error)
    }
  }, []);

  const handleAttachment = async (files) => {
    let attachments = [];
    let attachments_sizeKb = [];

    setFileSizeError("");
    if (files) {
      for (const file of files) {
        try {
          const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/png",
            "audio/mpeg",
            "video/mp4",
          ];
          if (!allowedTypes.includes(file.type)) {
            window.alert(
              "Invalid file type. Only PDF, JPEG, PNG, MP3, and MP4 files are allowed."
            );
            continue; // Skip this file and continue with the next one
          }

          const maxSizeInMB = file.type.startsWith("image")
            ? 10
            : file.type === "audio/mpeg"
              ? 10
              : 10;
          const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

          if (file.type === "application/pdf" && file.size > 10 * 1024 * 1024) {
            // window.alert("PDF file size exceeds 25 MB.");
            setFileSizeError("*The File You attached Exceeded 25MB.");
            continue; // Skip this file and continue with the next one
          } else if (file.size > maxSizeInBytes) {
            // window.alert(`File size exceeds ${maxSizeInMB} MB.`);
            setFileSizeError("*The File You attached Exceeded The Limit.");
            continue; // Skip this file and continue with the next one
          }

          let formData = new FormData();
          formData.append("name", file.name);
          formData.append("uploadQuestionAttachment", file);
          let res = await axios.post(
            `/api/v1/question/uploadAttachment/teacherId/${teacher_id}`,
            formData
          );

          attachments_sizeKb.push(Math.round(file.size / 1024));
          res && attachments.push(res.data.data);
        } catch (error) {
          console.log(error);
        }
      }
      if (attachments.length > 0) {
        setQuestions((prev) => {
          const updatedQuestion = {
            ...prev[questionNo],
            attachments: [...prev[questionNo].attachments, ...attachments], // Append new attachments to the existing ones
            attachments_sizeKb,
          };
          const newQuestion = [...prev];
          newQuestion[questionNo] = updatedQuestion;
          return newQuestion;
        });
      }
    }
  };
  const handleMarksChange = (e) => {
    const enteredValue = e.target.value;

    const regex = /^\d{0,3}$/;

    if (!regex.test(enteredValue)) {
      return;
    }

    setQuestions((prev) => {
      const updatedQuestion = {
        ...prev[questionNo],
        correct_score: enteredValue,
      };
      const newQuestion = [...prev];
      newQuestion[questionNo] = updatedQuestion;
      return newQuestion;
    });
  };
  const handleMarksKeyDown = (e) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      "Home",
      "End",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
    ];

    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };
  return (
    <>
      <div className="d-flex align-items-center justify-content-center ">
        <div className="col-11 m-0 mt-2 p-3 question_box_container  ">
          <div className=" d-flex">
            <div className="hw_question_no me-2">Q{questionNo + 1}</div>
            <input
              onChange={(e) =>
                setQuestions((prev) => {
                  const updatedQuestion = {
                    ...prev[questionNo],
                    title: e.target.value,
                  };
                  const newQuestion = [...prev];
                  newQuestion[questionNo] = updatedQuestion;
                  return newQuestion;
                })
              }
              maxLength={250}
              className="hw_question_box "
              placeholder="Add question"
              value={question?.title}
            />
            <Popup
              on="click"
              trigger={
                <div className="hw_three_dots">
                  <img src="/images/three dot hr.svg" alt=""></img>
                </div>
              }
              content={
                <div className="hw_popup_box_size">
                  <ThreeDot
                    questionIndex={questionNo}
                    setQuestion={setQuestions}
                  />
                </div>
              }
            />
          </div>
          <div className=" mt-2 d-flex align-items-center hw_default_dropdown_container ">
            <div className=" hw_default_dropdown_size">
              <span className="hw_default_dropdown_box_header">
                KNOWLEDGE DOMAIN
              </span>
              <select
                onChange={(e) =>
                  setQuestions((prev) => {
                    const updatedQuestion = {
                      ...prev[questionNo],
                      domain_id: e.target.value,
                    };
                    const newQuestion = [...prev];
                    newQuestion[questionNo] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question?.domain_id}
                label={domains?.some((d) => d.id === question.domain_id).name}
                className="form-select hw_default_sub_dropdown_size"
              >
                <option value="null">Select Knowledge Domain</option>
                {domains &&
                  domains.map((domain, index) => (
                    <option key={index} value={domain.id}>
                      {domain.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="hw_default_dropdown_size">
              <span className="hw_default_dropdown_box_header">SKILLS</span>
              <select
                onChange={(e) =>
                  setQuestions((prev) => {
                    const updatedQuestion = {
                      ...prev[questionNo],
                      skill_id: e.target.value,
                    };
                    const newQuestion = [...prev];
                    newQuestion[questionNo] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question?.skill_id}
                label={skills?.some((s) => s.id === question?.skill_id).name}
                className="form-select hw_default_sub_dropdown_size"
              >
                <option value="null" placeholder="dd">
                  Select Skill
                </option>
                {skills &&
                  skills?.map((skill, index) => (
                    <option key={index} value={skill.id} placeholder="dd">
                      {skill.name}
                    </option>
                  ))}
              </select>
              <span onClick={() => setClick(true)} style={{ position: "absolute", left: "37%", fontSize: "12px", color: "red", cursor: "pointer" }}>Click here to more details</span>
            </div>
            <div
              style={{ marginTop: "-6px" }}
              className="hw_default_dropdown_card"
            >
              <span className="hw_default_dropdown_box_header">CHAPTER</span>
              {/* <select
                                id="bookChapterSelect"
                                className="hw_default_sub_dropdown_size form-select"
                                onChange={(e) =>
                                    setQuestions((prev) => {
                                        const updatedQuestion = {
                                            ...prev[questionNo],
                                            chapter_id: e.target.value,
                                            book_id:
                                                e.target.options[e.target.selectedIndex].getAttribute(
                                                    "book-id"
                                                ),
                                        };
                                        const newQuestion = [...prev];
                                        newQuestion[questionNo] = updatedQuestion;
                                        return newQuestion;
                                    })
                                }
                                value={question?.chapter_id}
                            >
                                <option value="null">Select Chapter</option>
                                {chapters?.length > 0 &&
                                    chapters?.map((bookChapter, index) => (
                                        <optgroup
                                            label={bookChapter?.name}
                                            key={index}
                                            bookId={bookChapter?.id}
                                        >
                                            {bookChapter?.chapters?.length > 0 &&
                                                bookChapter?.chapters?.map((chapter, index) => (
                                                    <option
                                                        key={index}
                                                        book-id={bookChapter?.id}
                                                        book-name={bookChapter?.name}
                                                        value={chapter?.id}
                                                    >
                                                        {chapter?.name}
                                                    </option>
                                                ))}
                                        </optgroup>
                                    ))}
                            </select> */}
              <select
                id="bookChapterSelect"
                className="hw_default_sub_dropdown_size form-select"
                onChange={(e) =>
                  setQuestions((prev) => {
                    const updatedQuestion = {
                      ...prev[questionNo],
                      chapter_id: e.target.value,
                      book_id:
                        e.target.options[e.target.selectedIndex].getAttribute(
                          "book-id"
                        ),
                    };
                    const newQuestion = [...prev];
                    newQuestion[questionNo] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question.chapter_id}
              >
                <option value="null">Select Chapter</option>
                {chapters?.length > 0 &&
                  chapters?.map((item) =>
                    item.bookInfo.map((book) => (
                      <optgroup
                        label={book.name} // Display book name as the group label
                        key={book.id}
                        book-id={book.id}
                      >
                        {book.chapterData.map((chapter) => (
                          <option
                            key={chapter.id}
                            book-id={book.id}
                            book-name={book.name}
                            value={chapter.id}
                          >
                            {chapter.chapterName}
                          </option>
                        ))}
                      </optgroup>
                    ))
                  )}
              </select>
            </div>
            <div className="hw_default_dropdown_size">
              <span className="hw_default_dropdown_box_header">
                TYPE OF QUESTION
              </span>

              <select
                onChange={(e) =>
                  setQuestions((prev) => {
                    let updatedQuestion;
                    if (
                      e.target.options[e.target.selectedIndex].getAttribute(
                        "data-is-manually-graded"
                      ) === "true"
                    ) {
                      updatedQuestion = {
                        ...prev[questionNo],
                        type_id: e.target.value,
                        question_type: String(
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "data-is-manually-graded"
                          )
                        ),
                        options: [],
                        correct_answers: [
                          {
                            reason_for_answer: {
                              explanation: null,
                              attachments: null,
                            },
                          },
                        ],
                      };
                    } else {
                      updatedQuestion = {
                        ...prev[questionNo],
                        type_id: e.target.value,
                        question_type: String(
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "data-is-manually-graded"
                          )
                        ),
                        options: [
                          {
                            key: String.fromCharCode(0 + 65),
                            value: null,
                          },
                          {
                            key: String.fromCharCode(1 + 65),
                            value: null,
                          },
                        ],
                      };
                    }

                    const newQuestion = [...prev];
                    newQuestion[questionNo] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question?.type_id}
                label={types?.some((t) => t.id === question.type_id).name}
                className="form-select hw_default_sub_dropdown_size"
              >
                <option value="null">Select QuestionType</option>
                {types &&
                  types?.map((type, index) => (
                    <option
                      key={index}
                      value={type.id}
                      data-is-manually-graded={type?.is_manually_graded}
                    >
                      {type.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="mt-2 hw_default_dropdown_container  d-flex align-ites-center justify-content-between">
            <div className=" d-flex align-items-center gap-5">
              <div className="hw_mandatory_checkbox ">
                <input
                  onChange={() =>
                    setQuestions((prev) => {
                      const updatedQuestion = {
                        ...prev[questionNo],
                        add_to:
                          prev[questionNo].add_to === null
                            ? "homework"
                            : prev[questionNo].add_to === "assessment"
                              ? "all"
                              : "assessment",
                      };
                      const newQuestion = [...prev];
                      newQuestion[questionNo] = updatedQuestion;
                      return newQuestion;
                    })
                  }
                  type="checkbox"
                  checked={
                    question?.add_to === "homework" ||
                    question?.add_to === "all"
                  }
                />
                &nbsp;
                <span>Add for Homework</span>
              </div>
              <div className="hw_mandatory_checkbox ">
                <input
                  onChange={() =>
                    setQuestions((prev) => {
                      const updatedQuestion = {
                        ...prev[questionNo],
                        add_to:
                          prev[questionNo].add_to === null
                            ? "assessment"
                            : prev[questionNo].add_to === "homework"
                              ? "all"
                              : "homework",
                      };
                      const newQuestion = [...prev];
                      newQuestion[questionNo] = updatedQuestion;
                      return newQuestion;
                    })
                  }
                  type="checkbox"
                  checked={
                    question?.add_to === "assessment" ||
                    question?.add_to === "all"
                  }
                />
                &nbsp;
                <span>Add for Assessment</span>
              </div>
              <div className="hw_mandatory_checkbox ">
                <input
                  onChange={() =>
                    setQuestions((prev) => {
                      const updatedQuestion = {
                        ...prev[questionNo],
                        add_to_mock: !question?.add_to_mock
                      };
                      const newQuestion = [...prev];
                      newQuestion[questionNo] = updatedQuestion;
                      return newQuestion;
                    })
                  }
                  type="checkbox"
                  checked={question?.add_to_mock}
                />
                &nbsp;
                <span>Add for Mock</span>
              </div>
            </div>
            <div className="p-0 time_duration_box d-flex justify-content-between ">
              <div
                style={{
                  width: "calc(50% - 2px)",
                  transform: "translateX(10px)",
                }}
              >
                <span className="hw_default_dropdown_box_header">MARKS</span>
                <input
                  onChange={handleMarksChange}
                  onKeyDown={handleMarksKeyDown}
                  type="text"
                  className="form-control hw_default_sub_dropdown_size"
                  placeholder="Enter Marks"
                  maxLength="3"
                  value={question?.correct_score}
                />
              </div>
              <div style={{ width: "50%" }}>
                <span className="hw_default_dropdown_box_header">
                  LEVEL OF DIFFICULTY
                </span>
                <select
                  onChange={(e) =>
                    setQuestions((prev) => {
                      const updatedQuestion = {
                        ...prev[questionNo],
                        difficulty_level: e.target.value,
                      };
                      const newQuestion = [...prev];
                      newQuestion[questionNo] = updatedQuestion;
                      return newQuestion;
                    })
                  }
                  value={question?.difficulty_level}
                  label={
                    difficultyLevels?.some(
                      (d) => d.id === question.difficulty_level
                    ).name
                  }
                  className="form-select hw_default_sub_dropdown_size"
                >
                  <option value="null">Select Difficulty</option>
                  {difficultyLevels &&
                    difficultyLevels.map((difficultyLevel, index) => (
                      <option key={index} value={difficultyLevel.id}>
                        {difficultyLevel.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>
          <p className="SelectStyl">
            {/* Here update the text */}
            {`*Selection will add question to library so that you can re-use it through "Add from School Library" during creation.`}
          </p>
          {
            <>
              <div className=" mt-2 hw_default_dropdown_container d-flex ">
                <input
                  onChange={(e) => {
                    handleAttachment(e.target.files);
                  }}
                  multiple
                  type="file"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  id={`attachFile${questionNo}`}
                  style={{ display: "none" }}
                />
                <label className="pt-1" htmlFor={`attachFile${questionNo}`}>
                  <img src="/images/Attach.svg" alt="" />
                  <span className="hw_mandatory_checkbox">&nbsp;Attach</span>
                </label>
                <p className="ErrorMessage">{fileSizeerror}</p>
                {question?.attachments.length > 0 &&
                  question?.attachments.map((attachment, idx) => (
                    <CrossAttachmentAssessment
                      key={idx}
                      attachment={attachment}
                      isEditable={true}
                      setQuestions={setQuestions}
                      nextQuestion={questionNo}
                    />
                  ))}
              </div>
            </>
          }
          {question.question_type !== "" &&
            question.question_type === "false" ? (
            <CreateMcq
              nextQuestion={questionNo}
              question={question}
              setQuestions={setQuestions}
            />
          ) : (
            <CreateUploadType
              nextQuestion={questionNo}
              question={question}
              setQuestions={setQuestions}
            />
          )}
          {
            click && <Guides setClick={setClick} />
          }
        </div>
      </div>
    </>
  );
}
